import CalEmbed from '../components/CalEmbed';
import '../styles/page-book-demo.css';
import '../styles/page-resource-optimizer.css';
import Seo from '../components/Seo';

/* Same Cal.com link the host's /resource-optimizer/book uses. */

const STEPS = [
  { n: '01', t: 'We map your team', d: 'A quick walkthrough of your workflows and where the hours actually go.' },
  { n: '02', t: 'We identify the leaks', d: 'Three to five specific areas, each with the time and cost quantified.' },
  { n: '03', t: 'We show the fix', d: 'Exactly which systems remove each problem. No vague promises.' },
];

export default function ResourceOptimizerBookPage() {
  return (
    <>
      <Seo title="Book a Free Audit — Resource Optimizer | TeamGrid™" description="Book a free 30-minute audit. We find where hours leak in your workflows and show what can be automated." noindex />
      <header className="f-hero">
        <div className="container">
          <div className="f-grid">
            <div>
              <span className="hero-badge"><img className="mark" src="/assets/mark-teamgrid.svg" alt="" />Free 30-minute audit <span className="arr">›</span></span>
              <h1 style={{ fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: 700, color: 'var(--ink-hero)', margin: '20px 0 14px' }}>
                Find the leaks<br /><span style={{ color: '#a9aab3' }}>in thirty minutes</span>
              </h1>
              <p style={{ fontSize: '15.5px', lineHeight: '24px', color: 'var(--ink-soft)', marginBottom: '22px' }}>
                Our analysts show you three to five places where your team is bleeding time and money.
                No pitch deck. No sales script. Just numbers from your own week.
              </p>
              <div style={{ border: '1px solid var(--line)', borderRadius: '20px', background: '#fff', padding: '26px 28px' }}>
                <span className="fl" style={{ color: '#007A6E' }}>WHAT HAPPENS IN 30 MIN</span>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '16px' }}>
                  {STEPS.map((s) => (
                    <li key={s.n} style={{ display: 'flex', gap: '14px' }}>
                      <span style={{ fontSize: '13px', fontWeight: 800, color: '#2DBDB8', flex: '0 0 auto', paddingTop: '2px' }}>{s.n}</span>
                      <span>
                        <span style={{ display: 'block', fontSize: '14.5px', fontWeight: 700, color: 'var(--ink-strong)', marginBottom: '3px' }}>{s.t}</span>
                        <span style={{ display: 'block', fontSize: '13px', lineHeight: '19px', color: 'var(--ink-soft)' }}>{s.d}</span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="fcard2">
              <CalEmbed height={700} inline title="Book a 30-minute audit" />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
